import { useNavigate } from "react-router-dom";
import ArrowLeftSLineIcon from "remixicon-react/ArrowLeftSLineIcon";
import UploadCloud2LineIcon from "remixicon-react/UploadCloud2LineIcon";
import PlayCircleFillIcon from "remixicon-react/PlayCircleFillIcon";
import CloseLineIcon from "remixicon-react/CloseLineIcon";
import DeleteBin5FillIcon from "remixicon-react/DeleteBin5FillIcon";
import Header from "../../components/Header/Header"
import SideNavbar from "../../components/Navbar/SideNavbar"
import { useParams } from 'react-router-dom';
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getReviews, updateReview, generatePresignedUrl } from "../../../core/actionCreators/rmActionCreator";
import toast from "react-hot-toast";

const Review = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const params = useParams()
    const [loader, setLoader] = useState(false)
    const [mediaUploading, setMediaUploading] = useState(false)
    const [lightbox, setLightbox] = useState<{ type: 'image' | 'video', url: string } | null>(null)

    const [review, setReview] = useState({
        productMsn: "",
        isApproved: "",
        isActive: "",
        reviewId: "",
        rating: "",
        reviewSubject: "",
        reviewText: "",
        userId: "",
        userName: "",
        images: "",
        videos: "",
        isEnabled: "",
        merchandiseReplyText: ""
    })

    useEffect(() => {
        if (params.id) {
            dispatch(getReviews(`id=${params.id}`, (reviews: any) => {
                if (reviews.reviewsList && Array.isArray(reviews.reviewsList) && reviews.reviewsList.length === 1) {
                    setReview({ ...reviews.reviewsList[0] })
                }
                else {
                    toast.error('Review not found.')
                }
            }))
        }
    }, [params])


    const backArrowClickHadler = () => {
        navigate('/review')
    }

    const toUrlList = (value: string) => value ? String(value).split(',').map((url) => url.trim()).filter(Boolean) : []

    const removeMedia = (field: 'images' | 'videos', idx: number) => {
        const list = toUrlList((review as any)[field])
        const [removedUrl] = list.splice(idx, 1)
        setReview((prev: any) => ({ ...prev, [field]: list.join(',') }))
        setLightbox((prev) => (prev && prev.url === removedUrl ? null : prev))
    }

    const mediaUploadChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0]
        if (!file) return

        const isVideo = file.type.startsWith('video/')
        const fileType = isVideo ? 'video' : 'image'
        const field = isVideo ? 'videos' : 'images'

        setMediaUploading(true)
        dispatch(generatePresignedUrl(
            { fileType, fileName: file.name, contentType: file.type, contentLength: file.size, file },
            (err: any, result: any) => {
                setMediaUploading(false)
                e.target.value = ''
                if (err || !result?.fileUrl) {
                    toast.error('Failed to upload media.')
                    return
                }
                setReview((prev: any) => ({
                    ...prev,
                    [field]: prev[field] ? `${prev[field]},${result.fileUrl}` : result.fileUrl
                }))
                toast.success('Media uploaded.')
            }
        ))
    }

    const updateReviewClickHandler = () => {
        //Review
        review["isEnabled"] = review["isActive"]
        const payload = {
            ...review,
            mediaInfo: {
                imagesUrls: toUrlList(review.images),
                videosUrls: toUrlList(review.videos)
            }
        }
        setLoader(true)
        dispatch(updateReview(payload, (updateReviewApiRes: string) => {
            setLoader(false)
            toast.success(updateReviewApiRes)
        }))
    }


    return (
        <>
            {lightbox && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-6"
                    onClick={() => setLightbox(null)}
                >
                    <button
                        type="button"
                        title="Close"
                        onClick={() => setLightbox(null)}
                        className="absolute top-5 right-5 h-9 w-9 flex items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20"
                    >
                        <CloseLineIcon size={20} />
                    </button>
                    {lightbox.type === 'image' ? (
                        <img
                            src={lightbox.url}
                            alt="review-media-preview"
                            className="max-h-[85vh] max-w-[90vw] rounded shadow-2xl"
                            onClick={(e) => e.stopPropagation()}
                        />
                    ) : (
                        <video
                            src={lightbox.url}
                            controls
                            autoPlay
                            className="max-h-[85vh] max-w-[90vw] rounded shadow-2xl"
                            onClick={(e) => e.stopPropagation()}
                        />
                    )}
                </div>
            )}
            <div className="flex mainWrapper w-full">
                <div className="sidenav-wrapper">
                    <SideNavbar />
                </div>
                <div className="right-container">
                    <div className="header-container">
                        <Header />
                    </div>
                    <div className="body-container bg-white" >
                        <div className="Subheader bg-white p-[15px] shadow-[0_2px_6px_rgba(0,0,0,.1)]">
                            <div className="flex items-center w-full">
                                <ArrowLeftSLineIcon onClick={backArrowClickHadler} size={24} className="mr-4" />
                                <p className="text-xl font-bold text-[#43425D] flex items-center"> Review Update #{params.id}</p>
                            </div>
                        </div>
                        <div className="p-4 pb-8">
                            <div className="w-full bg-white py-4 px-2.5 shadow-[0_1px_4px_rgba(0,0,0,.2)] rounded mb-5">
                                <form>
                                    <div className="flex w-full mb-6 last:mb-0">
                                        <div className="w-1/2 px-2">
                                            <label className="block text-xs mb-1.5 text-[#5E5D5D] font-medium" htmlFor="msn">MSN*</label>
                                            <input
                                                className="w-full h-9 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-sm font-light"
                                                type="text"
                                                value={review.productMsn} onChange={(e) => setReview({ ...review, productMsn: e.target.value })}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="flex w-full mb-6 last:mb-0">
                                        <div className="w-1/2 px-2">
                                            <label htmlFor='isEnabled' className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">Enable</label>
                                            <select
                                                value={JSON.stringify(review.isActive)} onChange={(e) => setReview({ ...review, isActive: e.target.value })}
                                                id="isEnabled"
                                                className="w-full h-9 rounded border text-sm text-[#555] border-[#EAEAEA] px-2.5 outline-none bg-white font-light">
                                                <option value='true'>True</option>
                                                <option value='false'>False</option>
                                            </select>
                                        </div>
                                        <div className="w-1/2 px-2">
                                            <label htmlFor='isApproved' className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">Approve</label>
                                            <select
                                                id="isApproved"
                                                value={review.isApproved} onChange={(e) => setReview({ ...review, isApproved: e.target.value })}
                                                className="w-full h-9 rounded border text-sm text-[#555] border-[#EAEAEA] px-2.5 outline-none bg-white font-light">
                                                <option value='true'>True</option>
                                                <option value='false'>False</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="flex w-full mb-6 last:mb-0">
                                        <div className="w-1/2 px-2">
                                            <label htmlFor='reviewId' className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">ReviewId</label>
                                            <input
                                                className="w-full h-9 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-sm font-light"
                                                type="text"
                                                disabled
                                                value={review.reviewId} onChange={(e) => setReview({ ...review, reviewId: e.target.value })}
                                                id="reviewId"
                                            />
                                        </div>
                                        <div className="w-1/2 px-2">
                                            <label htmlFor='rating' className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">Rating</label>
                                            <input
                                                className="w-full h-9 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-sm font-light"
                                                type="text"
                                                id="rating"
                                                value={review.rating} onChange={(e) => setReview({ ...review, rating: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                    <div className="flex w-full mb-6 last:mb-0">
                                        <div className="w-1/2 px-2">
                                            <label htmlFor='reviewSubject' className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">Review Subject</label>
                                            <input
                                                className="w-full h-9 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-sm font-light"
                                                type="text"
                                                id="reviewSubject"
                                                value={review.reviewSubject} onChange={(e) => setReview({ ...review, reviewSubject: e.target.value })}
                                            />
                                        </div>
                                        <div className="w-1/2 px-2">
                                            <label htmlFor='reviewText' className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">Review text</label>
                                            <input
                                                className="w-full h-9 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-sm font-light"
                                                type="text"
                                                id="reviewText"
                                                value={review.reviewText} onChange={(e) => setReview({ ...review, reviewText: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                    <div className="flex w-full mb-6 last:mb-0">
                                        <div className="w-1/2 px-2">
                                            <label htmlFor='userId' className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">User Id</label>
                                            <input
                                                className="w-full h-9 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-sm font-light"
                                                type="text"
                                                disabled
                                                id="userId"
                                                value={review.userId} onChange={(e) => setReview({ ...review, userId: e.target.value })}
                                            />
                                        </div>
                                        <div className="w-1/2 px-2">
                                            <label htmlFor='userName' className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">User name</label>
                                            <input
                                                className="w-full h-9 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-sm font-light"
                                                type="text"
                                                disabled
                                                id="userName"
                                                value={review.userName} onChange={(e) => setReview({ ...review, userName: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                    <div className="flex w-full mb-6 last:mb-0">
                                        <div className="w-full px-2">
                                            <div className="flex items-center justify-between mb-2">
                                                <label className="block text-xs text-[#5E5D5D] font-medium">Media</label>
                                                <span className="text-[11px] text-[#9CA3AF]">
                                                    {toUrlList(review.images).length} image{toUrlList(review.images).length === 1 ? '' : 's'} · {toUrlList(review.videos).length} video{toUrlList(review.videos).length === 1 ? '' : 's'}
                                                </span>
                                            </div>
                                            <div className="flex flex-wrap gap-3">
                                                {toUrlList(review.images).map((url, idx) => (
                                                    <div
                                                        key={`img-${idx}`}
                                                        onClick={() => setLightbox({ type: 'image', url })}
                                                        className="relative group h-24 w-24 rounded-lg overflow-hidden border border-[#EAEAEA] bg-[#F7F7F8] cursor-pointer"
                                                    >
                                                        <img
                                                            src={url}
                                                            alt={`review-image-${idx + 1}`}
                                                            className="h-full w-full object-cover transition-transform duration-150 group-hover:scale-105"
                                                            onError={(e) => { (e.target as HTMLImageElement).style.display = 'none' }}
                                                        />
                                                        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors" />
                                                        <button
                                                            type="button"
                                                            title="Remove"
                                                            onClick={(e) => { e.stopPropagation(); removeMedia('images', idx) }}
                                                            className="absolute top-1 right-1 h-5 w-5 flex items-center justify-center rounded-full bg-black/60 text-white opacity-0 group-hover:opacity-100 transition-opacity"
                                                        >
                                                            <DeleteBin5FillIcon size={12} />
                                                        </button>
                                                    </div>
                                                ))}
                                                {toUrlList(review.videos).map((url, idx) => (
                                                    <div
                                                        key={`vid-${idx}`}
                                                        onClick={() => setLightbox({ type: 'video', url })}
                                                        className="relative group h-24 w-24 rounded-lg overflow-hidden border border-[#EAEAEA] bg-[#111827] cursor-pointer"
                                                    >
                                                        <video
                                                            src={url}
                                                            muted
                                                            preload="metadata"
                                                            className="h-full w-full object-cover opacity-80"
                                                            onError={(e) => { (e.target as HTMLVideoElement).style.display = 'none' }}
                                                        />
                                                        <div className="absolute inset-0 flex items-center justify-center">
                                                            <PlayCircleFillIcon size={28} className="text-white drop-shadow" />
                                                        </div>
                                                        <button
                                                            type="button"
                                                            title="Remove"
                                                            onClick={(e) => { e.stopPropagation(); removeMedia('videos', idx) }}
                                                            className="absolute top-1 right-1 h-5 w-5 flex items-center justify-center rounded-full bg-black/60 text-white opacity-0 group-hover:opacity-100 transition-opacity"
                                                        >
                                                            <DeleteBin5FillIcon size={12} />
                                                        </button>
                                                    </div>
                                                ))}
                                                <label
                                                    htmlFor="mediaUpload"
                                                    className={`h-24 w-24 flex flex-col items-center justify-center gap-1 rounded-lg border border-dashed transition-colors cursor-pointer ${mediaUploading
                                                        ? 'border-[#3B86FF] bg-[#3b86ff0d] text-[#3B86FF]'
                                                        : 'border-[#D8D8D8] text-[#9CA3AF] hover:border-[#3B86FF] hover:bg-[#3b86ff0d] hover:text-[#3B86FF]'
                                                        }`}
                                                >
                                                    {mediaUploading ? (
                                                        <>
                                                            <span className="h-4 w-4 rounded-full border-2 border-[#3B86FF] border-t-transparent animate-spin" />
                                                            <span className="text-[10px] font-medium">Uploading</span>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <UploadCloud2LineIcon size={20} />
                                                            <span className="text-[10px] font-medium">Add Media</span>
                                                        </>
                                                    )}
                                                    <input
                                                        id="mediaUpload"
                                                        type="file"
                                                        accept="image/*,video/*"
                                                        className="hidden"
                                                        disabled={mediaUploading}
                                                        onChange={mediaUploadChangeHandler}
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex w-full mb-6 last:mb-0">
                                        <div className="w-1/2 px-2">
                                            <label className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">Reply</label>
                                            <input
                                                className="w-full h-9 rounded border text-[#555] border-[#EAEAEA] p-2 outline-none text-sm font-light"
                                                type="text"
                                                value={review.merchandiseReplyText} onChange={(e) => setReview({ ...review, merchandiseReplyText: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="mt-5">
                                <button disabled={loader} type='submit' onClick={updateReviewClickHandler} className="h-9 py-2 px-4 bg-[#3b86ff1a] text-xs text-[#3B86FF] border border-[#3B86FF] rounded focus:outline-none ">{loader ? "Loading..." : "Save"}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Review;